import * as React from "react";
import { SVGProps } from "react";
const SvgCurrencyPound = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.672 23v-2.124h-4.554v-2.43h2.79v-1.602h-2.79v-1.818c0-1.224.468-1.962 1.584-1.962.936 0 1.548.432 2.25 1.188l1.656-1.728c-1.044-1.062-2.088-1.872-4.032-1.872-3.06 0-4.104 2.106-4.104 4.41v1.782h-1.08v1.602h1.08L12.454 23h7.218Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCurrencyPound;
